import React from 'react';
import cn from 'classnames';
import { colors } from '../config';

const Pill = ({ label, id, checked, ...rest }) => (
  <label htmlFor={id} className={cn('pill', checked && 'is-active')} {...rest}>
    <input type="radio" id={id} />
    <span>{label}</span>

    <style jsx>{`
      .pill {
        background-color: transparent;
        border: 1px solid ${colors.orange};
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 12px;
        border-radius: 999px;
        width: 80px;
        margin-right: 8px;
        cursor: pointer;
        color: ${colors.orange};
      }

      .pill.is-active {
        background-color: ${colors.orange};
        color: #fff;
      }

      input {
        display: none;
      }
    `}</style>
  </label>
);

export default Pill;
